import {
  FETCH_TEAM_MEMBERS,
  FETCH_MY_TEAM_PERMISSIONS,
} from "../constants/teamMembers";

const initialState = {
  teamMembers: [],
  isPaid: false,
  remainingSlots: 0,
  maxTeamMembers: 3,
  myPermissions: null, // null until fetched; { is_team_member, active, permissions } once loaded
};

export default function teamMembers(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEAM_MEMBERS:
      return {
        ...state,
        teamMembers: action.data.team_members,
        isPaid: action.data.is_paid,
        remainingSlots: action.data.remaining_slots,
        maxTeamMembers: action.data.max_team_members,
      };

    case FETCH_MY_TEAM_PERMISSIONS:
      return {
        ...state,
        myPermissions: action.data,
      };

    default:
      return state;
  }
}
